const getPeriodNames = {
    day: ' do dia',
    month: 'do mês',
    custom: 'do período',
    week: 'da semana',
};

const defaultPanelFilters = ['Todos', 'Vendas', 'Devoluções', 'Cancelamentos'];

const maisCarrinhoFilters = ['Todos', 'Pendentes', 'Finalizados'];

const availaleBrandsFilter = [
    'Animale',
    'Farm',
    'Farm Etc',
    'A.Brand',
    'Fábula',
    'OffPremium',
    'Foxton',
    'CrisBarros',
    'Maria Filó',
];

const channelFilter = [
    {
        value: 'allOrders',
        label: 'Todas',
    },
    {
        value: 'Linx',
        label: 'Linx',
    },
    {
        value: 'Online',
        label: 'Online',
    },
    {
        value: 'Vitrine',
        label: 'Vitrine',
    },
    {
        value: 'Box',
        label: 'Box',
    },
    {
        value: 'Joias',
        label: 'Joias',
    },
    {
        value: 'Vintage',
        label: 'Vintage',
    },
];

export {
    getPeriodNames,
    defaultPanelFilters,
    availaleBrandsFilter,
    channelFilter,
    maisCarrinhoFilters,
};
